module.exports = __webpack_public_path__ + "img/box.7d32c52.svg";